import { Outlet } from 'react-router-dom'

import BottomNavBar from '@/components/common/bar/BottomNavBar'
import { ErrorProvider } from '@/contexts/ErrorContext'

const MainLayout = () => {
  return (
    <ErrorProvider>
      <div className='min-h-screen bg-gradient-to-r from-amber-400 to-yellow-300'>
        <Outlet />
        <BottomNavBar />
      </div>
    </ErrorProvider>
  )
}

export default MainLayout
